import { type V2Bag, type V2Value } from "@/features/applications/api/applications.api";
import { Button } from "@/components/ui/button";
import { type FieldDef } from "../model";
import { SectionCard } from "../primitives";
import { useReadOnly } from "../readonly";
import { FieldGrid, AddrCard } from "../FieldGrid";

export function BusinessStep({
  fields, bag, onChange, onCopy,
}: {
  fields: FieldDef[];
  bag: V2Bag;
  onChange: (key: string, value: V2Value) => void;
  onCopy: (from: "legal" | "dba", to: "legal" | "dba") => void;
}) {
  const readOnly = useReadOnly();
  const sec = (name: string) => fields.filter((d) => d.section === name);
  const card = (title: string, name: string) => {
    const items = sec(name);
    return items.length ? (
      <SectionCard title={title}>
        <FieldGrid fields={items} bag={bag} onChange={onChange} />
      </SectionCard>
    ) : null;
  };
  return (
    <div className="space-y-5">
      <SectionCard title="Business Information">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <AddrCard title="Legal" fields={sec("Legal entity")} bag={bag} onChange={onChange} />
          <AddrCard title="DBA" fields={sec("DBA / location")} bag={bag} onChange={onChange} />
        </div>
        {!readOnly && (
          <div className="flex flex-wrap justify-center gap-3 my-4">
            <Button type="button" variant="outline" size="sm" onClick={() => onCopy("legal", "dba")}>
              → Copy Legal to DBA
            </Button>
            <Button type="button" variant="outline" size="sm" onClick={() => onCopy("dba", "legal")}>
              ← Copy DBA to Legal
            </Button>
          </div>
        )}
        <div className="border-t border-slate-100 pt-5">
          <FieldGrid fields={sec("Business details")} bag={bag} onChange={onChange} />
        </div>
      </SectionCard>
      {card("Emails", "Emails")}
      {card("Contact", "Contact")}
      {card("Previous bankruptcies", "Previous bankruptcies")}
      {card("IRS / W-9", "IRS / W-9")}
    </div>
  );
}
